module.exports = __webpack_public_path__ + "static/footer-left-vector-b0ddd8050d24422c3d271a2f79d669ff.svg";